// Additional polyfills
import 'custom-event-polyfill'
import 'url-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import '@/permission'
import { BootstrapVue, ToastPlugin } from 'bootstrap-vue'
import flatpickr from 'flatpickr'
import { Turkish } from 'flatpickr/dist/l10n/tr.js'
import VueClipboard from 'vue-clipboard2'
import globals from './globals'
import Popper from 'popper.js'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import messages from './mixins/messages'
import Toasted from 'vue-toasted'
import browserDetect from 'vue-browser-detect-plugin'
import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'
import { Yetki } from '@/utils/enums'
import Layout1 from '@/layout/Layout1'

Vue.use(Toasted)
Vue.use(VueClipboard)

flatpickr.localize(Turkish)

// Required to enable animations on dropdowns/tooltips/popovers
Popper.Defaults.modifiers.computeStyle.gpuAcceleration = false
Vue.use(browserDetect)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(ToastPlugin)

// Global RTL flag
Vue.mixin({
  data: globals
})
Vue.mixin(messages)
if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    Vue,
    dsn: 'https://235209f425184ac3b9fb2c2a2a1f36c5@o287898.ingest.sentry.io/6459993',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['localhost', 'yazokulu.hayrategitim.com', /^\//]
      })
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0
  })
}

if (globals().proje2021Mi) {
  router.addRoutes([{
    path: '/',
    redirect: '/anasayfa',
    component: Layout1,
    children: [{
      path: 'sertifika',
      name: 'sertifika',
      meta: [{
        Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
      }],
      component: () => import('@/views/sertifika2021')
    }]
  }])
}

if (globals().proje2022Mi) {
  router.addRoutes([{
    path: '/',
    redirect: '/anasayfa',
    component: Layout1,
    children: [{
      path: 'sertifika',
      name: 'sertifika',
      meta: [{
        Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
      }],
      component: () => import('@/views/sertifika2022')
    }]
  }])
}

if (globals().proje2023Mu) {
  router.addRoutes([{
    path: '/',
    redirect: '/anasayfa',
    component: Layout1,
    children: [{
      path: 'sertifika',
      name: 'sertifika',
      meta: [{
        Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
      }],
      component: () => import('@/views/sertifika2023')
    }]
  }])
}

if (globals().proje2024Mu) {
  router.addRoutes([{
    path: '/',
    redirect: '/anasayfa',
    component: Layout1,
    children: [{
      path: 'sertifika',
      name: 'sertifika',
      meta: [{
        Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
      }],
      component: () => import('@/views/sertifika2024')
    }]
  }])
}

if (globals().proje2025Mu) {
  router.addRoutes([{
    path: '/',
    redirect: '/anasayfa',
    component: Layout1,
    children: [{
      path: 'sertifika',
      name: 'sertifika',
      meta: [{
        Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
      }],
      component: () => import('@/views/sertifika2025')
    }]
  }])
}

if (globals().proje2026Mi) {
  router.addRoutes([{
    path: '/',
    redirect: '/anasayfa',
    component: Layout1,
    children: [{
      path: 'sertifika',
      name: 'sertifika',
      meta: [{
        Roles: [Yetki.SUPERADMIN, Yetki.ADMIN, Yetki.BOLGE, Yetki.ULKE, Yetki.IL, Yetki.ILCE, Yetki.HOCA]
      }],
      component: () => import('@/views/sertifika2026')
    }]
  }])
}

window.lokum = new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
